import { render } from "./EmbedHoliday.vue?vue&type=template&id=af9ed2ae"
import script from "./EmbedHoliday.vue?vue&type=script&lang=js"
export * from "./EmbedHoliday.vue?vue&type=script&lang=js"

import "./EmbedHoliday.vue?vue&type=style&index=0&id=af9ed2ae&lang=scss"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__